<template>
  <div class="app-content content ">
    <div class="content-overlay"></div>
    <div class="header-navbar-shadow"></div>
    <div class="content-wrapper">
      <div class="content-header row">
        <div class="content-header-left col-md-9 col-12 mb-2">
          <Breadcrumb
              name="Vp Accounts"
              bc1="App"
              bc2="Vp Accounts"
              bc3="Accounts"
          ></Breadcrumb>
        </div>
        <div
            class="content-header-right text-md-right col-md-3 col-12 d-md-block d-none"
        >
        </div>
      </div>
      <div class="content-body">
        <div class="col-12 d-flex mt-2  justify-content-center" v-if="loader">
          <div class="spinner-border text-primary"></div>
        </div>
        <section v-else class="app-user-list">
          <section  v-for="(eachAccountData,accountKey) in accounts" :key="accountKey">
            <div class="row">
              <div class="col-sm-12">
                <div class="card">
                  <div class="card-header">
                    <h4 class="card-title">{{accountKey}}</h4>
                  </div>
                  <div class="card-body">
                    <div class="row mt-5">
                      <div class="col-12">
                        <div class="card">
                          <div class="table-responsive">
                            <table class="table">
                              <thead>
                              <tr>
                                <th>Account Title</th>
                                <th>Account Number</th>
                                <th>Balance</th>
                                <th>Balance On Hold</th>
                                <th>Available Balance</th>
                                <th>Currency</th>
                                <th>Action</th>
<!--                                <th>Created Date</th>-->

                              </tr>
                              </thead>
                              <tbody>
                              <tr v-for="(account,accountIndex) in eachAccountData" :key="accountIndex">
                                <td><span class="badge badge-glow badge-info">{{ account.account_title }}</span></td>
                                <td><span>{{ account.account_number }}</span></td>
                                <td><span  class=" font-weight-bolder text-dark">{{modifyAmount(parseFloat(account.balance / 100).toFixed(amountDecimalPlaces))}}</span></td>
                                <td ><span  class=" font-weight-bolder text-dark">{{modifyAmount(parseFloat(account.balance_on_hold / 100).toFixed(amountDecimalPlaces))}}</span>
                                  <br> <span class="badge badge-light-warning mt-sm-25" style="cursor: pointer" @click="$router.push({name: 'balance-on-hold',params: {id:account.id, uuid: account.id}})">view ledger</span>
                                </td>
                                <td ><span  class=" font-weight-bolder text-dark">{{modifyAmount(parseFloat(account.available_balance / 100).toFixed(amountDecimalPlaces))}}</span></td>
                                <td ><span class="badge badge-light-success">{{account.currency.code}}</span></td>
<!--                                <td ><button class="btn btn-sm btn-warning" @click="$router.push({name: 'revenue-summary',params: {id:account.currency_id,currency: account.currency.code}})">View Summary</button></td>-->
                                <td ><button class="btn badge badge-light-primary" @click="$router.push({name: 'account-ledger-vp',params: {id:account.id}})">View Ledger</button></td>
                              </tr>
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>

        </section>


      </div>
    </div>
  </div>
</template>

<script>


export default {

  mounted() {
    this.sendCall()
  },
  data() {
    return {
      accounts: [],
      loader:false
    }
  },
  methods: {
    sendCall() {
      this.loader = true
      this.makeRequest('post', 'v1/vp-accounts', {}, {}, false).then(callResponse => {

        this.loader = false
        if (!callResponse.error) {
          let code = callResponse.response.data.code;

          if (code == 200) {
            let data = callResponse.response.data.data
            this.accounts = data
          }
        }

      });

    },
  },

}
</script>


